var map = {
	"./Agenda": "i7Pl",
	"./Agenda.js": "i7Pl",
	"./Agenda2021": "UnyC",
	"./Agenda2021.js": "UnyC",
	"./AllArticles": "EQ/Q",
	"./AllArticles.js": "EQ/Q",
	"./AllItems": "2rDR",
	"./AllItems.js": "2rDR",
	"./AllTalks": "JGFt",
	"./AllTalks.js": "JGFt",
	"./Appear": "zEWM",
	"./Appear.js": "zEWM",
	"./Button": "5Wrh",
	"./Button.js": "5Wrh",
	"./Container": "VUD3",
	"./Container.js": "VUD3",
	"./Day": "kG4S",
	"./Day.js": "kG4S",
	"./DetailBigImage": "9XJS",
	"./DetailBigImage.js": "9XJS",
	"./DetailInlineImageArticle": "KYSk",
	"./DetailInlineImageArticle.js": "KYSk",
	"./DetailInlineImageTalk": "vg4r",
	"./DetailInlineImageTalk.js": "vg4r",
	"./DetailTalkSpeaker": "PPfE",
	"./DetailTalkSpeaker.js": "PPfE",
	"./DetailTalkWrapper": "mmCb",
	"./DetailTalkWrapper.js": "mmCb",
	"./DetailTextBlock": "GDal",
	"./DetailTextBlock.js": "GDal",
	"./DetailTitle": "4DbE",
	"./DetailTitle.js": "4DbE",
	"./Event": "mldr",
	"./Event.js": "mldr",
	"./Footer": "JwsL",
	"./Footer.js": "JwsL",
	"./GridItem": "FWoE",
	"./GridItem.js": "FWoE",
	"./HTMLText": "hyvg",
	"./HTMLText.js": "hyvg",
	"./Hero": "1oc3",
	"./Hero.js": "1oc3",
	"./Image": "5Epl",
	"./Image.js": "5Epl",
	"./Items": "Sykr",
	"./Items.js": "Sykr",
	"./Layout": "7oih",
	"./Layout.js": "7oih",
	"./Menu2021": "RN73",
	"./Menu2021.js": "RN73",
	"./ModuleIterator": "tkU8",
	"./ModuleIterator.js": "tkU8",
	"./Page": "uVCN",
	"./Page.js": "uVCN",
	"./Related": "jfNf",
	"./Related.js": "jfNf",
	"./Related2021Talks": "hAf2",
	"./Related2021Talks.js": "hAf2",
	"./RelatedArticles": "01wP",
	"./RelatedArticles.js": "01wP",
	"./RelatedTalks": "YvKi",
	"./RelatedTalks.js": "YvKi",
	"./SimpleLanding": "1nEM",
	"./SimpleLanding.js": "1nEM",
	"./Speaker": "Za+B",
	"./Speaker.js": "Za+B",
	"./Speakers2021": "+OwL",
	"./Speakers2021.js": "+OwL",
	"./SvgArrowDown": "Udmk",
	"./SvgArrowDown.js": "Udmk",
	"./SvgFacebookLogo": "1P6I",
	"./SvgFacebookLogo.js": "1P6I",
	"./SvgHeart": "xvDS",
	"./SvgHeart.js": "xvDS",
	"./SvgInstagramLogo": "qdBA",
	"./SvgInstagramLogo.js": "qdBA",
	"./SvgLinkedInLogo": "eN2I",
	"./SvgLinkedInLogo.js": "eN2I",
	"./SvgMeaninfulLogo": "5rny",
	"./SvgMeaninfulLogo.js": "5rny",
	"./SvgPinkShape": "ltCk",
	"./SvgPinkShape.js": "ltCk",
	"./SvgTFLogo": "uyK1",
	"./SvgTFLogo.js": "uyK1",
	"./SvgTwitterLogo": "6HFL",
	"./SvgTwitterLogo.js": "6HFL",
	"./SvgTypeformLogo": "l7N/",
	"./SvgTypeformLogo.js": "l7N/",
	"./SvgTypeformLogo2": "/0RW",
	"./SvgTypeformLogo2.js": "/0RW",
	"./SvgYoutubeLogo": "8yzn",
	"./SvgYoutubeLogo.js": "8yzn",
	"./Talk2021": "Yzt5",
	"./Talk2021.js": "Yzt5",
	"./VideoBlock": "JFJ0",
	"./VideoBlock.js": "JFJ0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GwNf";